import { render, staticRenderFns } from "./ApiResponse.vue?vue&type=template&id=3ab2068b&scoped=true&"
import script from "./ApiResponse.vue?vue&type=script&lang=js&"
export * from "./ApiResponse.vue?vue&type=script&lang=js&"
import style0 from "./ApiResponse.vue?vue&type=style&index=0&id=3ab2068b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab2068b",
  null
  
)

export default component.exports